import { TABLE_VERSION_REQUEST, TABLE_VERSION_SUCCESS, TABLE_VERSION_FAILURE } from '../types';

const initialState = {
  tables: {},
  loading: false,
  error: null
};

const tableVersionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TABLE_VERSION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case TABLE_VERSION_SUCCESS:
      return {
        ...state,
        tables: action.payload || {},
      };
    case TABLE_VERSION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default tableVersionReducer;
